import React, { useEffect, useState, useLayoutEffect, useRef } from "react";
import { InputNumber } from "antd";
import "./index.less";
const isSelected = (value, item, labelInValue) => {
  if (labelInValue) {
    return value && item && value.id === item.id;
  }
  return value === item.id;
};

const Senser = ({ children, check, callback }) => {
  const ref = useRef();
  useEffect(() => {
    let bound = ref.current.getBoundingClientRect();
    let f = check(bound);
    f && callback();
  }, [children]);
  return <div ref={ref}>{children}</div>;
};
const OverflowWrap = ({ children, Toggler }) => {
  const [overflowedIndex, setOverflowed] = useState();
  const [showAll, setToggle] = useState(false);
  const boundRef = useRef();
  const needHide = (i) => !showAll && overflowedIndex &&i >= overflowedIndex;
  return (
    <>
      {React.Children.map(children, (child, i) =>
        needHide(i) ? null : (
          <Senser
            check={(bound) => {
              if (!boundRef.current) {
                boundRef.current = bound;
                return false;
              } else {
                let lastBound = boundRef.current;
                let f = false;
                if (bound.top > lastBound.top) {
                  f = true;
                }
                boundRef.current = bound;
                return f;
              }
            }}
            callback={() => {
              setOverflowed((p) => {
                if (p) return p;
                return i;
              });
            }}
          >
            {child}
          </Senser>
        )
      )}
      {overflowedIndex ? (
        <Toggler
          showAll={showAll}
          onClick={() => {
            setToggle((p) => !p);
          }}
        />
      ) : null}
    </>
  );
};
const Flip = ({ options, value, onChange, opts = {}, name }) => {
  const { icon, gap = 16, render, labelInValue, disabled, height = 32 } = opts;
  const ref = useRef();
  if (disabled) {
    return (
      <div className="TUI-Flip--Wrap TUI-Flip--Wrap__disabled">
        <div
          className="TUI-Flip"
          style={{
            overflow: "hidden",
          }}
          ref={ref}
        >
          {(options || [])
            .filter((d) =>
              typeof value === "object" ? value.id === d.id : value === d.id
            )
            .map((d) => (
              <div
                key={d.id}
                className={["TUI-Flip--Item"].join(" ")}
              >
                {icon}
                {typeof render === "function" ? (
                  render(d, value, disabled)
                ) : (
                  <span>{d.name}</span>
                )}
              </div>
            ))}
        </div>
      </div>
    );
  }
  if (!options || !options.length) {
    return (
      <div className="TUI-Flip--Wrap TUI-Flip--Wrap__disabled">
        <div
          className="TUI-Flip"
          style={{ overflow: "hidden", height: height }}
          ref={ref}
        >
          <div className="TUI-Flip--Item">
            <span>暂无数据</span>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="TUI-Flip--Wrap">
      <div
        className="TUI-Flip"
        style={{ overflow: "hidden", height: height }}
        ref={ref}
      >
        <OverflowWrap
          key={options}
          Toggler={({ onClick, showAll }) => (
            <div
              className={[
                "TUI-Flip--Toggler",
                showAll ? "TUI-Flip--Toggler__active" : "",
              ].join(" ")}
              onClick={() => {
                ref.current.style.overflow = showAll ? "hidden" : "unset";
                ref.current.style.height = showAll ? height + "px" : "auto";
                onClick();
              }}
            >
              {showAll ? "收起" : "更多"}
            </div>
          )}
        >
          {(options || []).map((d) => (
            <div
              key={d.id}
              data-id={d.id}
              style={{ marginBottom: gap + "px", marginRight: gap + "px" }}
              className={[
                "TUI-Flip--Item",
                isSelected(value, d, labelInValue)
                  ? "TUI-Flip--Item__selected"
                  : "",
              ].join(" ")}
              onClick={() => onChange(labelInValue ? d : d.id)}
            >
              {icon}
              {typeof render === "function" ? (
                render(d, value, disabled, onChange)
              ) : (
                <span>{d.name}</span>
              )}
            </div>
          ))}
        </OverflowWrap>
      </div>
    </div>
  );
};
const defaultItemRenderComponent = ({ value, onChange, style }) => {
  return (
    <InputNumber
      value={value}
      onChange={onChange}
      min={1}
      max={100}
      style={style}
    />
  );
};
const createItemRender = (Component = defaultItemRenderComponent) => {
  return (item, current, disabled, onChange) => {
    if (item.$mutable) {
      let [head, end] = item.name.split(/\d+/);
      let [num = 1] = /\d+/.exec(item.name) || [];
      return (
        <div
          style={{
            display: "inline-flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <span>{head}</span>
          {disabled ? (
            <span>{num}</span>
          ) : (
            <Component
              value={num}
              onChange={(v) => {
                item.name = item.name.replace(/\d+/, v);
                onChange({ ...item });
              }}
              style={{
                margin: "0 4px",
                width: "4em",
              }}
            />
          )}
          <span>{end}</span>
        </div>
      );
    }
    return item.name;
  };
};
Flip.createItemRender = createItemRender;
export default Flip;
